export default __webpack_public_path__ + "static/media/Background.21d06861.jpg";